import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTimeFlies: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTimeFlies"><Path fillRule="evenodd" clipRule="evenodd" d="M7 12C7 7.58172 10.5817 4 15 4C19.4183 4 23 7.58172 23 12C23 16.4183 19.4183 20 15 20C10.5817 20 7 16.4183 7 12ZM2 7H6V9H2V7ZM16 8V11.5858L17.9142 13.5L16.5 14.9142L14 12.4142V8H16ZM1 11H5V13H1V11ZM2 15H6V17H2V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTimeFlies;
